import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureFlagService, FeatureFlags } from './feature-flag.service';
import { TenantService } from '../tenant/tenant.service';

export const featureGuard = (feature: keyof FeatureFlags): CanActivateFn => {
    return () => {
        const featureService = inject(FeatureFlagService);
        const tenantService = inject(TenantService);
        const router = inject(Router);

        const isFeatureEnabled = featureService.flags()[feature];
        const isEntitled = tenantService.hasFeature(feature);

        if (!isFeatureEnabled || !isEntitled) {
            // Redirect to dashboard if global flag is off OR tenant doesn't have it
            const slug = tenantService.tenantSlug();
            return router.createUrlTree([`/${slug}/admin/dashboard`]);
        }

        return true;
    };
};
